import { View, Text } from 'react-native'
import { LowesPlus } from '../icons/LowesPlus'
import { fontFamilies } from '@/src/common/theme'

interface LowesHowToItem {
  text: string
  subtext: string
}

interface LowesHowToItemsProps {
  instruction: LowesHowToItem
}

function LowesHowToItems({ instruction }: LowesHowToItemsProps) {
  return (
    <View
      style={{
        flexDirection: 'row',
      }}
    >
      <LowesPlus
        style={{
          marginLeft: 4,
          marginRight: 12,
          marginTop: 2,
        }}
      />
      <View>
        <Text
          style={{
            flexShrink: 1,
            color: '#0034AB',
            lineHeight: 19,
            fontSize: 16,
            fontFamily: fontFamilies['Poppins-SemiBold'],
            fontWeight: 600,
          }}
        >
          {instruction.text}
        </Text>
        <Text
          style={{
            flexShrink: 1,
            color: '#0034AB',
            lineHeight: 12,
            fontSize: 10,
            fontFamily: fontFamilies['Poppins-Regular'],
            fontWeight: 400,
          }}
        >
          {instruction.subtext}
        </Text>
      </View>
    </View>
  )
}

interface LowesHowToRedeemProps {
  howToRedeem: readonly LowesHowToItem[]
}

export function LowesHowToRedeem({ howToRedeem }: LowesHowToRedeemProps) {
  return (
    <View
      style={{
        marginTop: 16,
        gap: 8,
      }}
    >
      {howToRedeem.map((instruction) => (
        <LowesHowToItems instruction={instruction} key={instruction.text} />
      ))}
    </View>
  )
}
